<template>
	<div>
		<v-layout>
			<v-flex>
				<v-autocomplete
					label="Select State"
					v-model="selectedState"
					:items="states"
					:autcomplete="false"
					placeholder="Select State"
					class="body-1 text-field-wrapper pt-4"
					:loading="fetchStatesLoading"
				></v-autocomplete>
			</v-flex>
			<v-flex
				class="no-flex-grow verCenteredChild px-3"
				v-if="showFilter"
			>
				<v-menu
					v-model="menu"
					:close-on-content-click="false"
					:nudge-width="225"
					offset-y
				>
					<template v-slot:activator="{ on }">
						<v-btn color="grey" dark v-on="on">
							<v-icon left>filter_list</v-icon>Filter
						</v-btn>
					</template>

					<v-card class="pl-4 py-3">
						<div class="px-2 full-width">
							<h5 class="subheading mb-1">
								<strong>Filter By:</strong>
							</h5>
							<v-layout class="d-flex">
								<v-flex class="d-flex">
									<v-autocomplete
										v-model="filterCity"
										label="Select City"
										:items="cities"
										placeholder="Select City"
										class="body-1 text-field-wrapper pt-4"
										:autcomplete="false"
									></v-autocomplete>
								</v-flex>
								<v-flex class="mb-2 d-flex">
									<v-autocomplete
										v-model="filterMicroMarket"
										label="Select MicroMarket"
										placeholder="Select MicroMarket"
										class="body-1 text-field-wrapper pt-4"
										:items="micro_markets"
										:autcomplete="false"
									></v-autocomplete>
								</v-flex>
							</v-layout>
							<v-layout>
								<v-spacer />
								<v-btn flat @click="resetFilter">Reset</v-btn>
								<v-btn
									:color="themeInputColor"
									outline
									@click="applyFilter"
									>Apply</v-btn
								>
							</v-layout>
						</div>
					</v-card>
				</v-menu>
			</v-flex>
		</v-layout>
		<v-layout v-if="!showFilter">
			<v-flex>
				<v-autocomplete
					v-model="selectedCity"
					label="Select City"
					placeholder="Select City"
					class="body-1 text-field-wrapper pt-4"
					:items="cities"
					:autcomplete="false"
				></v-autocomplete>
			</v-flex>
			<v-flex>
				<v-autocomplete
					v-model="selectedMicroMarket"
					label="Select Micromarket"
					placeholder="Select Micromarket"
					class="body-1 text-field-wrapper pt-4"
					:items="micro_markets"
					:autcomplete="false"
				></v-autocomplete>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapState } from "vuex";

import { FETCH_REGIONS } from "@/store/action-types";

import { REGION_TYPE, themeInputColor } from "@/utils";

export default {
	name: "SelectStateCityMM",
	props: [
		"showFilter",
		"defaultState",
		"defaultCity",
		"defaultMicroMarket",
		"removeCityFilter",
		"removeMicroMarketFilter"
	],
	data() {
		return {
			selectedState: null,
			filterCity: null,
			selectedCity: null,
			filterMicroMarket: null,
			selectedMicroMarket: null,
			menu: false,
			fetchStatesLoading: false,
			fetchCitiesLoading: false,
			fetchMicroMarketsLoading: false,
			themeInputColor
		};
	},
	created() {
		if (!this.fetchStatesLoading) {
			this.fetchStatesLoading = true;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.STATE,
					dataKey: "states"
				})
				.catch(() => {})
				.then(() => {
					this.fetchStatesLoading = false;
				});
		}
	},
	mounted() {
		this.selectedState = this.defaultState;
		this.selectedCity = this.defaultCity;
		this.selectedMicroMarket = this.defaultMicroMarket;
	},
	computed: {
		...mapState({
			states: state => state.common.states,
			cities: state => state.common.cities,
			micro_markets: state => state.common.micro_markets
		}),
		feedAndFilterType() {
			let feedType = REGION_TYPE.STATE;
			let filterKey = this.selectedState;
			// console.log("selectedCity: ", this.selectedCity);
			if (this.selectedCity) {
				feedType = REGION_TYPE.CITY;
				filterKey = `${filterKey}_${this.selectedCity}`;
			}
			if (this.selectedMicroMarket) {
				feedType = REGION_TYPE.MICRO_MARKET;
				filterKey = `${filterKey}_${this.selectedMicroMarket}`;
			}
			return { feedType, filterKey };
		}
	},
	methods: {
		resetFilter() {
			this.filterCity = null;
			this.selectedCity = null;
			this.filterMicroMarket = null;
			this.selectedMicroMarket = null;
			this.sendUpdatedValues();
			this.menu = false;
		},
		applyFilter() {
			this.selectedMicroMarket = this.filterMicroMarket;
			this.selectedCity = this.filterCity;
			this.sendUpdatedValues();
			this.menu = false;
		},
		fetchCities(setDefault) {
			this.selectedCity = null;
			this.selectedMicroMarket = null;
			this.fetchCitiesLoading = true;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.CITY,
					state: this.selectedState,
					dataKey: "cities"
				})
				.catch(() => {})
				.then(() => {
					this.fetchCitiesLoading = false;
					if (setDefault) {
						this.selectedCity = this.defaultCity;
					}
				});
		},

		fetchMicroMarkets(state, city, setDefault) {
			this.fetchMicroMarketsLoading = true;
			this.selectedMicroMarket = null;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.MICRO_MARKET,
					state,
					city,
					dataKey: "micro_markets"
				})
				.catch(() => {})
				.then(() => {
					this.fetchMicroMarketsLoading = false;
					if (setDefault) {
						this.selectedMicroMarket = this.defaultMicroMarket;
					}
				});
		},
		sendUpdatedValues() {
			const { feedType, filterKey } = this.feedAndFilterType;

			// This is special case to handle the part in which default values should
			// not reset when the regions and micromarkets are fetched.
			if (
				(this.defaultState && !this.selectedState) ||
				(this.defaultCity && !this.selectedCity) ||
				(this.defaultMicroMarket && !this.selectedMicroMarket)
			) {
				return;
			}

			this.$emit(
				"UPDATED_VALUES",
				{
					selectedState: this.selectedState,
					selectedCity: this.selectedCity,
					selectedMicroMarket: this.selectedMicroMarket
				},
				feedType,
				filterKey
			);
		}
	},
	watch: {
		selectedState(newVal) {
			if (newVal) {
				const setDefault = newVal === this.defaultState;
				this.fetchCities(setDefault);
			}
			this.sendUpdatedValues();
		},
		selectedCity(newVal) {
			if (newVal) {
				const setDefault = newVal === this.defaultCity;
				this.fetchMicroMarkets(this.selectedState, newVal, setDefault);
			}
			if (!this.showFilter) this.sendUpdatedValues();
		},
		filterCity(newVal) {
			if (newVal) {
				this.fetchMicroMarkets(this.selectedState, newVal, false);
			}
		},
		selectedMicroMarket() {
			if (!this.showFilter) this.sendUpdatedValues();
		},
		defaultState(newVal) {
			this.selectedState = newVal;
		},
		defaultCity(newVal) {
			this.selectedCity = newVal;
		},
		defaultMicroMarket(newVal) {
			this.selectedMicroMarket = newVal;
		}
	}
};
</script>
